import React from 'react'

const SupportSidebar = () => (
    <>
        <h2>Contact Us</h2>

        <div id="contact-info">
            <h4>Address:</h4>
            <p>
                17036 Weston Bay Road
                <br />
                Eden Prairie MN, 55347
            </p>

            <h4>Email:</h4>
            <p>
                <a href="mailto:contact@oneprotection.tech">contact@oneprotection.tech</a>
            </p>
        </div>
    </>
)

export default SupportSidebar
